import React, { useState, useEffect } from 'react';
import { supabase, getTier, TIERS } from '../lib/supabase';

export default function Rewards() {
  const [leaders, setLeaders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchLeaders() {
      const { data } = await supabase
        .from('donors')
        .select('name, blood_group, ward, donated_count, points')
        .order('points', { ascending: false })
        .limit(20);
      setLeaders(data || []);
      setLoading(false);
    }
    fetchLeaders();
  }, []);

  const top3 = leaders.slice(0, 3);
  const rest = leaders.slice(3);

  return (
    <div className="page">
      {/* Header */}
      <div className="rewards-header">
        <div className="rewards-trophy">🏆</div>
        <div className="section-title" style={{ fontSize: 24, textAlign: 'center' }}>റിവാർഡ് ലീഡർബോർഡ്</div>
        <div className="section-sub" style={{ textAlign: 'center', marginTop: 4 }}>ദാനം ചെയ്യൂ · പോയിന്റ് നേടൂ · സമ്മാനം ജയിക്കൂ</div>
      </div>

      {/* How points work */}
      <div className="card" style={{ marginBottom: 24 }}>
        <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 12 }}>📋 എങ്ങനെ പോയിന്റ് നേടാം?</div>
        <div className="points-list">
          <div className="points-row"><span>✍️ രജിസ്റ്റർ ചെയ്യൂ</span><span className="points-badge">+10 pts</span></div>
          <div className="points-row"><span>🩸 ഓരോ ദാനത്തിനും</span><span className="points-badge">+50 pts</span></div>
          <div className="points-row"><span>🆘 അഭ്യർത്ഥന നിറവേറ്റൂ</span><span className="points-badge">+20 pts</span></div>
        </div>
      </div>

      {/* Tiers */}
      <div className="card" style={{ marginBottom: 24 }}>
        <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 12 }}>🎖️ ടയർ ലെവലുകൾ</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          {TIERS.map(t => (
            <div key={t.nameEn} className="tier-card">
              <span className="tier-icon">{t.icon}</span>
              <div>
                <div style={{ fontWeight: 700, fontSize: 14 }}>{t.name}</div>
                <div style={{ fontSize: 12, color: 'var(--text-3)' }}>{t.min}+ പോയിന്റ്</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Prize banner */}
      <div className="prize-banner">
        <div className="prize-banner-icon">🎁</div>
        <div>
          <div style={{ fontWeight: 800, fontSize: 16 }}>ഒന്നാം സ്ഥാനം — പ്രത്യേക സമ്മാനം!</div>
          <div style={{ fontSize: 13, opacity: 0.85, marginTop: 2 }}>ഏറ്റവും കൂടുതൽ പോയിന്റ് ഉള്ള ദാതാവിന് ഗ്രാമ പഞ്ചായത്ത് പ്രത്യേക അംഗീകാരവും സമ്മാനവും</div>
        </div>
      </div>

      {/* Top 3 podium */}
      {loading ? (
        <div className="loading"><div className="spinner"></div> ലോഡ് ചെയ്യുന്നു…</div>
      ) : leaders.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">🏆</div>
          <div className="empty-title">ഇതുവരെ ദാതാക്കളൊന്നുമില്ല</div>
          <div className="empty-sub">ആദ്യ ദാതാവ് ആകൂ!</div>
        </div>
      ) : (
        <>
          {top3.length > 0 && (
            <div className="podium">
              {/* 2nd */}
              {top3[1] && (
                <div className="podium-slot podium-2">
                  <div className="podium-rank">2</div>
                  <div className="podium-avatar" style={{ background: '#C0C0C0' }}>{top3[1].blood_group}</div>
                  <div className="podium-name">{top3[1].name}</div>
                  <div className="podium-pts">{top3[1].points || 0} pts</div>
                  <div className="podium-bar podium-bar-2"></div>
                </div>
              )}
              {/* 1st */}
              {top3[0] && (
                <div className="podium-slot podium-1">
                  <div className="podium-crown">👑</div>
                  <div className="podium-rank">1</div>
                  <div className="podium-avatar" style={{ background: '#FFD700', color: '#000' }}>{top3[0].blood_group}</div>
                  <div className="podium-name">{top3[0].name}</div>
                  <div className="podium-pts">{top3[0].points || 0} pts</div>
                  <div className="podium-bar podium-bar-1"></div>
                </div>
              )}
              {/* 3rd */}
              {top3[2] && (
                <div className="podium-slot podium-3">
                  <div className="podium-rank">3</div>
                  <div className="podium-avatar" style={{ background: '#CD7F32' }}>{top3[2].blood_group}</div>
                  <div className="podium-name">{top3[2].name}</div>
                  <div className="podium-pts">{top3[2].points || 0} pts</div>
                  <div className="podium-bar podium-bar-3"></div>
                </div>
              )}
            </div>
          )}

          {/* Rest of leaderboard */}
          {rest.length > 0 && (
            <div style={{ marginTop: 8 }}>
              {rest.map((donor, i) => {
                const tier = getTier(donor.points || 0);
                return (
                  <div key={i} className="leader-row">
                    <div className="leader-rank">{i + 4}</div>
                    <div className="blood-badge" style={{ background: 'var(--red)', width: 36, height: 36, fontSize: 11 }}>
                      {donor.blood_group}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 600, fontSize: 14 }}>{donor.name}</div>
                      <div style={{ fontSize: 12, color: 'var(--text-3)' }}>{donor.ward?.split(' - ')[0]} · {donor.donated_count || 0}× ദാനം</div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontWeight: 700, color: 'var(--red)', fontSize: 15 }}>{donor.points || 0}</div>
                      <div style={{ fontSize: 11 }}>{tier.icon} {tier.name}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
    </div>
  );
}
